import { jsx as _jsx } from "react/jsx-runtime";
// Non-consistent length of array will cause hydration issue with next
export default function DateSkeleton({ daysToList }) {
    return (_jsx("div", { className: "relative flex w-full justify-start gap-2", children: Array(daysToList)
            .fill(null)
            .map(() => null) }));
}
